import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function PricingSection() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const mockupUrl = 'https://cdn.magicpatterns.com/uploads/2bhUqhVfWCjsiC5Nb3JXQb/Party-Favor-Templates-Mockup-Bundle-5x7-CANVA_use_1200x.webp';
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  const cardRef = useRef(null);
  const isCardInView = useInView(cardRef, {
    once: true,
    margin: '-100px'
  });
  // Countdown timer — resets every 24h from first visit
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const getEndTime = () => {
      const stored = localStorage.getItem('promo_end');
      if (stored) {
        const end = parseInt(stored, 10);
        if (end > Date.now()) return end;
      }
      const end = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('promo_end', end.toString());
      return end;
    };
    const endTime = getEndTime();
    const tick = () => {
      const diff = Math.max(0, endTime - Date.now());
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section className="w-full bg-pink-50 py-20 sm:py-28 overflow-hidden" data-id="element-165">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <motion.div ref={headerRef} className="text-center mb-6" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-167">
          <span className="inline-block px-6 py-2 bg-red-100 text-red-600 rounded-full text-sm font-bold mb-4 animate-pulse" data-id="element-168">
            ⏳ Precio de lanzamiento por tiempo limitado
          </span>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-slate-900" data-id="element-169">
            🔥 Oferta especial hoy
          </h2>
        </motion.div>

        {/* Countdown Timer */}
        <motion.div className="flex justify-center gap-4 mb-16" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isHeaderInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-170">
          {[{
          value: pad(timeLeft.hours),
          label: 'Horas'
        }, {
          value: pad(timeLeft.minutes),
          label: 'Min'
        }, {
          value: pad(timeLeft.seconds),
          label: 'Seg'
        }].map((unit, i) => <div key={i} className="flex flex-col items-center" data-id="element-171">
              <div className="w-20 h-20 sm:w-24 sm:h-24 bg-white rounded-2xl shadow-xl border-2 border-rose-200 flex items-center justify-center" data-id="element-172">
                <span className="text-3xl sm:text-4xl font-extrabold text-rose-600 tabular-nums" data-id="element-173">
                  {unit.value}
                </span>
              </div>
              <span className="text-xs sm:text-sm font-bold text-slate-500 mt-2" data-id="element-174">
                {unit.label}
              </span>
            </div>)}
        </motion.div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-12" data-id="element-175">
          {/* Image */}
          <motion.div className="w-full md:w-1/2 max-w-md relative" initial={{
          opacity: 0,
          x: -50
        }} animate={isCardInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7
        }} data-id="element-176">
            <div className="absolute inset-0 bg-rose-200 rounded-full blur-3xl opacity-50 animate-pulse" data-id="element-177"></div>
            <img src={mockupUrl} alt="" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl object-cover border-4 border-white -rotate-2" data-id="element-178" />
          </motion.div>

          {/* Pricing Card */}
          <motion.div ref={cardRef} className="w-full md:w-1/2 max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden pulse-glow" initial={{
          opacity: 0,
          y: 50,
          scale: 0.95
        }} animate={isCardInView ? {
          opacity: 1,
          y: 0,
          scale: 1
        } : {}} transition={{
          duration: 0.7,
          delay: 0.2
        }} data-id="element-179">
            {/* Savings banner */}
            <div className="bg-gradient-to-r from-amber-400 to-amber-500 py-3 text-center" data-id="element-180">
              <span className="text-white font-bold text-sm sm:text-base" data-id="element-181">
                🎉 Ahorrás más de $62.000 ARS — ¡69% OFF!
              </span>
            </div>

            <div className="p-8 sm:p-12 text-center" data-id="element-182">
              <div className="mb-8" data-id="element-183">
                <p className="text-slate-400 line-through text-2xl mb-2 font-medium" data-id="element-184">
                  $89.990
                </p>
                <div className="flex items-baseline justify-center gap-2" data-id="element-185">
                  <span className="text-6xl sm:text-7xl font-extrabold text-rose-600" data-id="element-186">
                    $27.990
                  </span>
                </div>
                <p className="text-slate-500 mt-3 text-lg font-medium" data-id="element-187">
                  pesos argentinos · pago único
                </p>
              </div>

              <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn block w-full py-6 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-xl font-bold rounded-2xl text-center shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300" initial={{
              opacity: 0
            }} animate={isCardInView ? {
              opacity: 1
            } : {}} transition={{
              duration: 0.4,
              delay: 0.6
            }} data-id="element-188">
                👉 Descargar el Mega Kit Ahora
              </motion.a>

              <p className="mt-4 text-sm font-semibold text-slate-500" data-id="element-189">
                ⚡ Acceso inmediato después de comprar.
              </p>

              <div className="mt-6 pt-6 border-t border-rose-100" data-id="element-190">
                <p className="text-xs text-slate-400" data-id="element-191">
                  🔒 Pago seguro · 📥 Descarga instantánea · 💬 Soporte incluido
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}